import { cx, css } from "react-emotion";
import { isMobile } from "components/ReactUtils/mobileDetect.js";
import { observer } from "mobx-react";
import React, { Fragment } from "react";
import ReactQuill from "react-quill"; // ES6
import { ProgressBar } from "react-bootstrap";

import theme from "components/theme";

// eslint-disable-next-line import/no-webpack-loader-syntax
import "!style-loader!css-loader!react-quill/dist/quill.snow.css";

import ProgressBar2 from "./../ProgressBar";

class InputHtml extends React.Component {
  quillRef = React.createRef();

  state = { focus: false };

  componentDidMount() {
    const { mountWithFocus } = this.props;
    if (mountWithFocus) this.input.focus();
  }

  onFocus = e => {
    this.setState(...this.state, { focus: true });
    this.props.onFocus && this.props.onFocus(e);
  };

  onBlur = e => {
    const { store, name, validateOnBlur = true } = this.props;

    if (validateOnBlur) store.validate([name]);
    else store.clearField(name);

    this.setState(...this.state, { focus: false });
    this.props.onBlur && this.props.onBlur(e);
  };

  render() {
    const {
      store,
      id,
      label,
      inputWidth = "",
      labelWidth = "",
      size = "md",
      formGroupAdd = [],
      inputGroupAdd = [],
      onChange,
      name,

      type,
      darkBg,
      mobileInline = false,
      inputGroup = false,
      mobileGroup = false,
      animatedLabel = true,
      animatedLabelAbove = false,
      errorPositionAbsolute = false,
      errorOnTop = false,
      tall = this.props.type === "textarea",
      labelNode = null,
      withProgress = false,
      progressLabel = "",
      progressBackgroundColor = "inherit",
    } = this.props;

    const { focus } = this.state;
    const { stylesEm, quillRef } = this;

    const mobileStyled = !mobileInline && isMobile();

    const value = (store && store.data && store.get(name)) || "";

    const animatedLabelUp = animatedLabel && (focus || value);
    let percent = 0;
    if (withProgress) {
      let length = (quillRef.current && quillRef.current.editor && quillRef.current.editor.getLength()) || 0;
      if (length >= 200) {
        length = 200;
      }
      percent = Math.round(length / 20) * 10;
    }

    let variant = "success";
    if (percent < 33) {
      variant = "danger";
    } else if (percent < 66) {
      variant = "warning";
    }

    const isIE = /*@cc_on!@*/ false || !!document.documentMode;

    const inputEl = (
      <Fragment>
        <div style={{ backgroundColor: "white" }}>
          <ReactQuill
            ref={quillRef}
            value={value}
            onChange={newValue => onChange({ target: { name, value: newValue } })}
            className={css`
              .ql-editor p {
                ${theme.fonts.normal};
                strong {
                  font-family: Avenir-Medium;
                  font-weight: 1000;
                }
              }
            `}
          />
        </div>
        {withProgress && (
          <div
            className={css`
              display: flex;
              background-color: ${progressBackgroundColor};
            `}
          >
            <div
              className={css`
                white-space: nowrap;
                font-size: 14px;
              `}
            >
              {progressLabel}
            </div>
            <div
              className={css`
                width: 100%;
                margin-left: 10px;
              `}
            >
              {isIE && <ProgressBar now={percent} bsStyle={variant} />}
              {!isIE && <ProgressBar2 percent={percent} trailColor={progressBackgroundColor} />}
            </div>
          </div>
        )}
      </Fragment>
    );

    return (
      <div
        className={[
          stylesEm.root,
          "inputText",
          animatedLabelAbove && "animatedLabelAbove",
          darkBg && "darkBg",
          animatedLabel && "placeholderToLabel",
          type === "textarea" && "textarea",
          tall && "tall",
          type === "money" && "money",
          focus && "focus",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <div
          className={[
            inputGroup && (mobileGroup || !mobileStyled) && "input-group",
            "position-relative",
            `input-group-${size}`,
          ]
            .filter(Boolean)
            .join(" ")}
        >
          {label && (
            <label
              htmlFor={id}
              onClick={() => this.input && this.input.focus()}
              className={[
                "control-label",
                labelWidth,
                animatedLabelUp ? "labelActive" : "labelUnactive",
                animatedLabelUp ? "lActive" : "lUnactive",
              ].join(" ")}
            >
              <span className={"labelText"}>{label || name}</span>
              {labelNode && <span className={"additionalLabel"}>{labelNode}</span>}
              {!animatedLabelAbove && <span className={["bg", "labelBackground"].join(" ")} />}
              {errorOnTop && store && store.errors && store.errors[name] && (
                <span className={"error"}>
                  <small>{store.errors[name][0]}</small>
                </span>
              )}
            </label>
          )}

          {!inputGroup && <div className={inputWidth}>{inputEl}</div>}
          {inputGroup && inputEl}

          {(mobileGroup || !mobileStyled) && inputGroupAdd}

          {formGroupAdd}
        </div>

        {!errorOnTop && store && store.errors && store.errors[name] && (
          <p className={cx(["error", stylesEm.error, errorPositionAbsolute && stylesEm.errorPositionAbsolute])}>
            <small>{store.errors[name][0]}</small>
          </p>
        )}

        {!mobileGroup && mobileStyled && inputGroupAdd}
      </div>
    );
  }

  stylesEm = {
    root: css`
      .ql-editor {
        min-height: 150px;
      }
      .additionalLabel {
        margin-left: 10px;
      }
    `,
    error: css`
      text-align: left !important;
    `,
    errorPositionAbsolute: css`
      position: absolute;
    `,
  };
}
// ref={instance => (this.input = instance)}

export default observer(InputHtml);
